import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./en/translations.json";
import translationSR from "./sr/translations.json";
import translationHU from "./hu/translations.json";
import translationRu from "./ru/translations.json";

const resources = {
  en: {
    translation: translationEN,
  },
  sr: {
    translation: translationSR,
  },
  hu: {
    translation: translationHU,
  },
  ru: {
    translation: translationRu,
  },
};

// Get the preferred language from local storage, if available
const savedLanguage = localStorage.getItem("language") || "sr";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
  .then(() => {
    console.log("i18n initialized successfully");
  })
  .catch((error) => {
    console.error("i18n initialization failed:", error);
  });

export default i18n;
